var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12.502","height":"20.569","viewBox":"0 0 12.502 20.569"}},[_c('g',{staticClass:"left-arrow"},[_c('path',{attrs:{"id":"Path_62","data-name":"Path 62","d":"M-7999.358-14667.33h20.569l-10.548,12.5Z","transform":"translate(-14654.828 7999.358) rotate(90)","fill":"#666"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }